import { EActionAttribute } from '@core/type';

import { Box } from '../layout';

export const PaginationEllipsis = () => (
  <Box as={EActionAttribute.LI} listStyleType={'none'}>
    <Box
      width={28}
      height={28}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={'50%'}
      pointerEvents={'none'}
      fontSize={'15'}
    >
      ...
    </Box>
  </Box>
);
